import { ErrorClassification } from '@sit/client-shared';
import toastr from './toastr';

export function updateNetworkStatus(isOnline: boolean) {
  if (!isOnline) {
    toastr.info('Internet connection restored', {
      toastId: 'API_NETWORK_INFO_ONLINE',
      dismissToastId: ErrorClassification.NETWORK_OFFLINE,
    });
  } else {
    toastr.error('No internet connection', {
      toastId: ErrorClassification.NETWORK_OFFLINE,
      dismissToastId: 'API_NETWORK_INFO_ONLINE',
    });
  }
}

window.addEventListener('online', () => updateNetworkStatus(true));
window.addEventListener('offline', () => updateNetworkStatus(false));
